module.exports = __webpack_public_path__ + "img/master-bedroom.13f70d15.svg";